import * as partnerManagementService from './partner-management-service';
import * as importExportService from './import-export-service';
import * as scheduleService from './schedule-service';
import * as simulationService from './simulation-service';
import * as orchestrationService from './orchestration-service';
import * as addressService from './address-service';
import * as upsRegistrationService from './ups-registration-service';
import * as labelaryService from './labelary-service';
import * as securityService from './security-service';
import * as partnerWebhooksService from './partner-webhooks-service';
import * as carrierService from './carrier-service';
import * as mastraService from './mastra-service';
import * as trackingProcessorService from './tracking-processor-service';
import * as deliveryExperienceService from './delivery-experience-service';

export {
  partnerManagementService,
  importExportService,
  scheduleService,
  simulationService,
  orchestrationService,
  addressService,
  upsRegistrationService,
  labelaryService,
  securityService,
  partnerWebhooksService,
  carrierService,
  mastraService,
  trackingProcessorService,
  deliveryExperienceService,
};

import { type Injections, injections } from '../store/services/injections';

const storeInjections = injections as Injections;

/**
 * We want to move all services outside of store directory
 */

export const {
  assetService,
  fulfillmentContextService,
  limitService,
  addressService: addressServiceDeprecated,
  simulationService: simulationServiceDeprecated,
  importExportService: importExportServiceDeprecated,
  UIOrchestrationService,
  shiptimeService,
  partnerService,
  ruleService,
  scheduleService: scheduleServiceDeprecated,
  datalakeService,
} = storeInjections;
